import { NgModule } from "@angular/core";
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { UIRouterModule } from '@uirouter/angular';
import { JwtModule } from '@auth0/angular-jwt';

import { settings } from './apps/settings/settings';
import { airModules, airModulesStateConfigFn } from './apps/airModules/airModules'
import { ng2RootState } from './root/ng2Root.stateconfig';
import { Ng2RootComponent } from './root/ng2Root.component';
import { AppServicesModule } from './commons/services/appServices.module';
import { AppApiServicesModule } from './commons/apiservices/api.services.module';
import { jwtOptionsProvider } from './commons/configs/jwt.config';
import { AppModulesModule } from './modules/appModules.module';
import { FormsModule } from '@angular/forms';
import { emads } from './apps/emads/emads';
import { pageTitleConfig } from './commons/configs/pageTitle.config';
import { airtrfx } from './apps/airtrfx/airtrfx';
import { authAndAppValidationConfigFn } from './commons/configs/authAndAppValidation.config';
import { preloaderConfigFn, preloaderInitProvider } from './commons/configs/preloader.config';
import { dataCollectionConfigFn } from './commons/configs/dataCollection.config';
import { NgApp } from "./app.component";
import { transitionErrorConfigFn } from "./commons/configs/transitionError.config";
import { OpHeader, OpHeaderItem } from "./components/opHeader/opHeader.component";
import { OpPrimarySidebar } from "./components/opPrimarySidebar/opPrimarySidebar.component";
import { OpEllipsis } from "./components/opEllipsis/opEllipsis.component";
import { emadsTrailingSlashConfigfn, otherwiseRule } from "./commons/configs/otherwise.config";
import { EmSidebar, EmSidebarTarget } from "@everymundo/em-cms-kit/emSidebar";
import { TokenModule } from './modules/token/token.module';
import { OpUserActions } from "./components/opUserActions/opUserActions.component";
import { OpAirlineSelector } from "./components/opAirlineSelector/opAirlineSelector.component";
import { OpAppsToggle } from "./components/opAppsToggle/opAppsToggle.component";
import { OpAppcuesLaunchpad } from "./components/opAppcuesLaunchpad/opAppcuesLaunchpad.component";

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from "@primeng/themes";
import { CdkScrollable } from "@angular/cdk/scrolling";

@NgModule({
  imports: [
    BrowserModule,
    UIRouterModule.forRoot({
        states: [ng2RootState],
        useHash: false,
        config: (router) => {
            router.urlService.config.hashPrefix('');
            router.urlService.rules.otherwise((_, parts) => otherwiseRule(parts.path, router));
            emadsTrailingSlashConfigfn(router);
            pageTitleConfig(router);
            authAndAppValidationConfigFn(router);
            preloaderConfigFn(router);
            dataCollectionConfigFn(router);
            transitionErrorConfigFn(router);
            airModulesStateConfigFn(router);
        }
    }),
    UIRouterModule.forChild({
        states: [
            settings,
            airModules,
            emads,
            airtrfx
        ]
    }),
    AppServicesModule,
    AppApiServicesModule,
    OpHeader,
    OpHeaderItem,
    OpUserActions,
    OpAirlineSelector,
    OpAppsToggle,
    OpAppcuesLaunchpad,
    OpPrimarySidebar,
    OpEllipsis,
    OpAppcuesLaunchpad,
    AppModulesModule,
    JwtModule.forRoot({ jwtOptionsProvider: jwtOptionsProvider }),
    FormsModule,
    TokenModule,
    EmSidebar,
    EmSidebarTarget,
    CdkScrollable
],
  declarations: [
    Ng2RootComponent,
    NgApp
  ],
  bootstrap: [
    NgApp
  ],
  providers: [
    preloaderInitProvider,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync('noop'),
    providePrimeNG({
      theme: {
        preset: definePreset({}),
        options: {
          prefix: 'p',
          darkModeSelector: false || 'none',
          cssLayer: false,
        },
      },
      ripple: false,
      overlayOptions: {
        appendTo: 'body',
      },
    }),
  ],
})
export class NgBootstrapModule { }
